import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DialogModule } from '../dialog/index';

import { PrintService } from './print.service';
import { PrintRef } from './classes/ref';
import { PrintParams } from './classes/params';

import { PrintWrapperComponent } from './components/wrapper/wrapper.component';

export { PrintService } from './print.service';

export * from './print.interface';

export { PrintRef } from './classes/ref';
export { Print } from './classes/print';
export { PrintParams } from './classes/params';

export { PrintWrapperComponent } from './components/wrapper/wrapper.component';

@NgModule({
  declarations: [
    PrintWrapperComponent
  ],
  entryComponents: [
    PrintWrapperComponent
  ],
  imports: [
    CommonModule,
    DialogModule
  ],
  exports: [
    PrintWrapperComponent,
  ],
  providers: [
    PrintService,
    PrintRef,
    PrintParams
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PrintModule {}
